export default __webpack_public_path__ + "static/media/Terminos y Condiciones RAC 20-04-2022.422123dc.pdf";